// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lmqpb","colMin":"styles_colMin__2UTgi"};